import React, { useMemo } from "react";
import {
  ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid,
} from "recharts";

export default function PriceChart({ history = [], height = 260, testid = "price-chart" }) {
  const data = useMemo(() => {
    const grouped = {};
    history.forEach((h) => {
      const t = new Date(h.captured_at).getTime();
      const key = Math.floor(t / (10 * 60_000)); // 10-min buckets
      const label = new Date(key * 10 * 60_000).toISOString();
      grouped[label] = grouped[label] || { t: label };
      grouped[label][h.outcome || "Yes"] = h.probability;
    });
    return Object.values(grouped).sort((a, b) => new Date(a.t) - new Date(b.t));
  }, [history]);

  const outcomes = useMemo(() => {
    const s = new Set();
    history.forEach((h) => s.add(h.outcome || "Yes"));
    return Array.from(s);
  }, [history]);

  if (!data.length) {
    return (
      <div
        data-testid={testid}
        className="border border-zinc-800 rounded-sm grid place-items-center text-xs text-zinc-500"
        style={{ height }}
      >
        No price history yet — data is captured on each sync.
      </div>
    );
  }

  const strokes = ["#e4e4e7", "#a1a1aa", "#71717a"];

  return (
    <div data-testid={testid} style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ left: 4, right: 8, top: 8, bottom: 4 }}>
          <CartesianGrid strokeDasharray="2 4" stroke="#27272a" vertical={false} />
          <XAxis
            dataKey="t"
            tickFormatter={(v) => {
              const d = new Date(v);
              return `${d.getMonth() + 1}/${d.getDate()} ${d.getHours()}:00`;
            }}
            stroke="#52525b"
            fontSize={10}
            tickLine={false}
          />
          <YAxis
            stroke="#52525b"
            fontSize={10}
            tickLine={false}
            tickFormatter={(v) => `${Math.round(v * 100)}%`}
            domain={[0, 1]}
          />
          <Tooltip
            contentStyle={{
              background: "#0b0b0f",
              border: "1px solid #27272a",
              fontSize: 11,
              color: "#e4e4e7",
            }}
            formatter={(v) => `${(v * 100).toFixed(1)}%`}
            labelFormatter={(l) => new Date(l).toLocaleString()}
          />
          {outcomes.map((o, i) => (
            <Line
              key={o}
              type="monotone"
              dataKey={o}
              stroke={strokes[i % strokes.length]}
              strokeWidth={1.5}
              dot={false}
              isAnimationActive={false}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
